import { CREATE_RULE, REVERT_RULE, CREATE_RULE_SUBMITTING, ERROR_ON_RULE_CREATION, ERROR_ON_SCAN, CLEAR_ERROR_ON_RULE_CREATION, FETCH_COLUMNS, FETCH_RULES, UPDATE_RULES_WORKTAG, DELETE_RULE, RULE_DELETING,INVALID_WORKTAGS,ERROR_ON_INVOKE_WORKTAGS_API, MERGE_RULES, INACTIVE_RULES_STATUS } from "../actions";
import { findRuleIndex } from "../util/util";

export function columns(state = [], action = {}) {
    return action.type === FETCH_COLUMNS ? action.payload : state;
}

export function errorOnRuleCreation(state = "", action = {}){
    switch(action.type){
        case ERROR_ON_RULE_CREATION:
            console.log("ERROR_ON_RULE_CREATION", action.payload);
            return action.payload;
        case CLEAR_ERROR_ON_RULE_CREATION:
            return "";
        default:
            return state;
    }
}

export function errorOnScan(state = "", action={}) {
    switch(action.type){
        case ERROR_ON_SCAN:
            console.log("ERROR_ON_SCAN", action.payload);
            return action.payload;
        default:
            return state;
    }
}

export function ruleSubmitting(state = false, action = {}){
    return action.type === CREATE_RULE_SUBMITTING ? action.payload : state;
}

export function rules(state = [], action = {}) {
    switch(action.type) {
        case FETCH_RULES:
            return action.payload;
        case UPDATE_RULES_WORKTAG:
            let updatedRules = action.payload;
            let updateState = [...state];
            for(let rule of updatedRules){
                let updateStateIndex = findRuleIndex(rule.id, updateState);
                updateState[updateStateIndex] = rule;
            }
            return updateState;
        case CREATE_RULE:
            let createdRule = action.payload;
            let createState = [...state, createdRule];
            return createState;
        case REVERT_RULE:
            let revertRule = action.payload;
            let revertState = [...state];
            let revertStateIndex = findRuleIndex(revertRule.id, revertState);
            (revertStateIndex > -1) && revertState.splice(revertStateIndex, 1);
            return revertState;
        case DELETE_RULE:
            let deletedRule = action.payload;
            let deleteState = [...state];
            let deleteStateIndex = findRuleIndex(deletedRule.id, deleteState);
            deleteState.splice(deleteStateIndex, 1); //delete  from state
            return deleteState;
        case MERGE_RULES:
            const updatedState = [...state]
            const newRules = action.payload
            newRules.forEach(newRule => {
                const { id, components, tran_account } = newRule
                const match = findRuleIndex(id, updatedState)
                const pkSkMatch = findMatch(updatedState, {
                    components, tran_account
                })
                if (match > -1) {
                    updatedState[pkSkMatch] = newRule
                } else if(pkSkMatch > -1) {
                    updatedState[match] = newRule
                } else {
                    updatedState.push(newRule)
                }
            })

            return updatedState
        default:
            return state;
    }
}

function findMatch(state = [], rule = {}) {
    const { components, tran_account } = rule

    const match = state.findIndex(o=> {
        return (components && tran_account) && 
        components === o.components &&
        tran_account === o.tran_account
    }) 
    
    return match
}

export function ruleDeleting(state = false, action = {}){
    return action.type === RULE_DELETING ? action.payload : state;
}

export function validateWorkTags(state = false, action = {}){
    switch(action.type) {
        case INVALID_WORKTAGS:
            return action.payload;
        case ERROR_ON_INVOKE_WORKTAGS_API:
            return action.payload;
        default:
            return state;
    }
}

export function inactiveStatus(state = 'IDLE', action = {}) {
    return action.type === INACTIVE_RULES_STATUS ? action.payload : state
}




// WEBPACK FOOTER //
// ./src/reducers/reducers-rules.js